module.exports = __webpack_public_path__ + "static/media/redDragonBack.01bbb1bb.png";